export const contactsStatic = {
    crumbsNav: [
        { id: 1, title: 'Home', link: '/' },
        { id: 2, title: 'Contacts', link: '/contacts/' },
      ],
};
